import { createCn } from 'cn/config'

/**
 * The class merger, taught the theme's own utilities.
 *
 * `cn` (and tailwind-merge, whose tables it ships) decides what a `text-*` class is by its
 * suffix: a t-shirt size or a length is a font size, anything else a colour. `text-13`, `text-15`
 * and `text-2xs` come from `--text-*` in `styles/globals.css`, so to the stock tables they read as
 * colours, and `cn('text-primary-foreground', 'text-15')` returned `text-15` alone. That is how the
 * ink button lost its paper text on every phone-height control in the hand-over. The same goes for
 * the three named shadows, which are shadows, not shadow colours.
 */
export const cn = createCn({
  extend: {
    classGroups: {
      'font-size': [{ text: ['2xs', '13', '15'] }],
      shadow: [{ shadow: ['card', 'lift', 'toast'] }],
    },
  },
})
